import { useSelector } from 'react-redux'

// import { ReactComponent as IconResize } from '@/assets/images/icons/icon-resize.svg'
import mapPlaceholder from '@/assets/images/map-placeholder.webp'

import { getStoreCityFromFormats, getStoreFormats } from '@/store/slices/app'
import { unixToMoment } from '@/utils/times'

import styles from './Maps.module.scss'
import { HERO_API } from '../../api'

function Maps() {
  const formats = useSelector(getStoreFormats)
  const selectedCity = useSelector(getStoreCityFromFormats)

  const getFormatTime = (format) => {
    const time = unixToMoment(format.start_time).tz(format.timezone)
    return `${format.title} ${time.format('HH:mm')}`
  }

  const sortedFormats = [...(formats || [])].sort((a, b) => {
    const timeA = unixToMoment(a.start_time).valueOf()
    const timeB = unixToMoment(b.start_time).valueOf()
    return timeA - timeB
  })

  return (
    <section className={styles.maps} id="map">
      <h2 className={styles.title}>Маршрут</h2>

      <div className={styles.main}>
        <div className={styles.filterWrap}>
          <p className={styles.label}>Маршруты забега славятся своей живописностью</p>

          <p className={styles.labelSecondary}>Место старта</p>
          <p className={`${styles.address} ${styles.text}`}>
            {selectedCity?.info?.start_address || 'Информация появится позже'}
          </p>

          <p className={styles.labelSecondary}>Время старта</p>
          <ul className={styles.items}>
            {formats &&
              selectedCity &&
              sortedFormats.map((format) => (
                <li className={`${styles.item} ${styles.text}`} key={format.public_id}>
                  {getFormatTime(format)}
                </li>
              ))}
            {/* <p className={`${styles.address} ${styles.text}`}>{'Информация появится позже'}</p> */}
          </ul>
        </div>

        <div className={styles.mapWrap}>
          {selectedCity?.info?.map_preview ? (
            <a
              {...(selectedCity?.info?.map_full && { href: `${HERO_API}${selectedCity.info.map_full}` })}
              target="_blank"
            >
              <img
                className={`${styles.map} lazyload`}
                src={`${HERO_API}${selectedCity.info.map_preview}`}
                width={644}
                height={450}
                alt=""
              />
            </a>
          ) : (
            <img className={`${styles.map} lazyload`} src={mapPlaceholder} width={644} height={450} alt="" />
          )}

          {/*<button className={styles.button}>*/}
          {/*  <IconResize />*/}
          {/*</button>*/}
        </div>
      </div>

      {selectedCity?.info?.legals && (
        <a
          className={styles.link}
          href={`${HERO_API}${selectedCity.info.legals}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Положение
        </a>
      )}
    </section>
  )
}

export default Maps
